import SystemOfflineMessage from './SystemOfflineMessage';

export default SystemOfflineMessage;
